import { LOCALES, KEYS } from '../constants';

const viVNTranslations = Object.freeze({
  [LOCALES.L18N_LOCALE_VIETNAMESE_VN] : {
    [KEYS.L18N_KEY_LABEL_PARTNER_ROLE ]:"Vai trò của đối tác",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR ]:"Nhà tích hợp",
    [KEYS.L18N_KEY_LABEL_PROVIDER ]:"Nhà cung cấp",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL]:"Cấp độ của đối tác",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATION ]:"Chuyên môn của đối tác",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICE ]:" Dịch vụ của Cisco",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME ]:"Tên đối tác",
    [KEYS.L18N_KEY_LABEL_LOCATION ]:"Vị trí",
    [KEYS.L18N_KEY_LABEL_COUNTRY ]:"Quốc gia",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD ]:"Từ khóa tên đối tác",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAME_KEYWORD_S_ ]:"(Các) Từ khóa tên đối tác",
    [KEYS.L18N_KEY_LABEL_SORTING ]:"Sắp xếp",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATIONS ]:"Chuyên môn",
    [KEYS.L18N_KEY_LABEL_PARTNER_SPECIALIZATIONS ]:"Chuyên môn của đối tác",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVEL_AND_CISCO_POWERED_SERVICES ]:"Cấp độ nhà cung cấp và Dịch vụ của Cisco",
    [KEYS.L18N_KEY_LABEL_GOLD_PROVIDER ]:"nhà cung cấp vàng",
    [KEYS.L18N_KEY_LABEL_PREMIER_PROVIDER ]:"nhà cung cấp cao cấp",
    [KEYS.L18N_KEY_LABEL_SELECT_PROVIDER ]:"nhà cung cấp chọn lọc",
    [KEYS.L18N_KEY_LABEL_ELOQUA__GET_GUIDANCE]:"Xem hướng dẫn",
    [KEYS.L18N_KEY_LABEL_ELOQUA__REQUEST_A_QUOTE ]:"Yêu cầu báo giá",
    [KEYS.L18N_KEY_LABEL_OPEN ]:" Mở",
    [KEYS.L18N_KEY_LABEL_EXPAND ]:"Mở rộng",
    [KEYS.L18N_KEY_LABEL_COLLAPSE ]:"Thu gọn",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_COUNTRY ]:"Chọn một quốc gia/khu vực",
    [KEYS.L18N_KEY_LABEL_CHOOSE_A_ROLE ]:"Chọn một vai trò",
    [KEYS.L18N_KEY_LABEL_CHOOSE_SPECIALIZATION_S_ ]:"Chọn (các) chuyên môn",
    [KEYS.L18N_KEY_LABEL_CHOOSE_CISCO_POWERED_SERVICE_S_ ]:"Chọn (các) dịch vụ của Ciso",
    [KEYS.L18N_KEY_LABEL_CHOOSE_EXPERTISE_S]:"Chọn chuyên môn",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LEVEL_S_ ]:"Chọn cấp độ",
    [KEYS.L18N_KEY_LABEL_PARTNER_COUNTRY ]:"Quốc gia/Khu vực của đối tác",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_LEVELS ]:"Cấp độ nhà tích hợp",
    [KEYS.L18N_KEY_LABEL_PROVIDER_LEVELS ]:"Cấp độ nhà cung cấp",
    [KEYS.L18N_KEY_LABEL_INTEGRATOR_SPECIALIZATIONS ]:"Chuyên môn của nhà tích hợp",
    [KEYS.L18N_KEY_LABEL_CISCO_POWERED_SERVICES ]:"Dịch vụ của Cisco",
    [KEYS.L18N_KEY_LABEL_PARTNER_NAMES ]:"Tên đối tác",
    [KEYS.L18N_KEY_LABEL_BACK ]:"Quay lại",
    [KEYS.L18N_KEY_LABEL_ALL_RESULTS]:"Tất cả kết quả",
    [KEYS.L18N_KEY_LABEL_ALL ]:"Tất cả ",
    [KEYS.L18N_KEY_LABEL_SAVED ]:"Đã lưu",
    [KEYS.L18N_KEY_LABEL_MY_PARTNERS ]:"Đối tác của tôi",
    [KEYS.L18N_KEY_LABEL_ADD ]:"Thêm",
    [KEYS.L18N_KEY_LABEL_REMOVE ]:"Loại bỏ",
    [KEYS.L18N_KEY_LABEL_ADD_TO_COMPARE ]:"Thêm để so sánh ",
    [KEYS.L18N_KEY_LABEL_SELECT_AT_LEAST_ONE_MORE ]:"Chọn ít nhất một mục nữa",
    [KEYS.L18N_KEY_LABEL_COMPARE_SELECTED ]:"So sánh mục đã chọn ",
    [KEYS.L18N_KEY_LABEL_REMOVE_FROM_COMPARATOR ]:"Xóa khỏi bộ so sánh",
    [KEYS.L18N_KEY_LABEL_COMPARE ]:"So sánh",
    [KEYS.L18N_KEY_LABEL_PARTNER_LEVEL ]:"Cấp độ của đối tác",
    [KEYS.L18N_KEY_LABEL_PROCESSING_IN_PROGRESS]:"Đang xử lý",
    [KEYS.L18N_KEY_LABEL_RESULT ]:"kết quả",
    [KEYS.L18N_KEY_LABEL_RESULTS ]:"kết quả",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS ]:"Không có kết quả",
    [KEYS.L18N_KEY_LABEL_RESULT_IN]:"kết quả trong",
    [KEYS.L18N_KEY_LABEL_RESULTS_IN]:"kết quả trong",
    [KEYS.L18N_KEY_LABEL_NO_RESULTS_IN]:"Không có kết quả nào trong",
    [KEYS.L18N_KEY_LABEL_PREVIOUS ]:"Trước",
    [KEYS.L18N_KEY_LABEL_PREV ]:"Trước",
    [KEYS.L18N_KEY_LABEL_NEXT ]:"Tiếp theo",
    [KEYS.L18N_KEY_LABEL_SAVE ]:"Lưu",
    [KEYS.L18N_KEY_LABEL_EXPERTISE ]:"Chuyên môn",
    [KEYS.L18N_KEY_LABEL_OVERVIEW ]:"Tổng quan",
    [KEYS.L18N_KEY_LABEL_IS_A_CISCO ]:"là Cisco",
    [KEYS.L18N_KEY_LABEL_ROLE_INTEGRATOR_DESCRIPTION]:"Nhà tích hợp xây dựng các giải pháp đầu cuối cho khách hàng của chúng tôi. Họ chủ yếu giao dịch theo phương thức bán lại nhưng sử dụng kinh nghiệm chuyên môn của mình để giải quyết các vấn đề kinh doanh của khách hàng",
    [KEYS.L18N_KEY_LABEL_ROLE_PROVIDER_DESCRIPTION ]:"Nhà cung cấp là những chuyên gia cung cấp các giải pháp được quản lý và giải pháp đám mây. Khách hàng mong muốn sử dụng các giải pháp một cách linh hoạt hơn và nhà cung cấp đang ngày càng trở nên quan trọng trên thị trường.",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCHES ]:"Mục tìm kiếm trước đây",
    [KEYS.L18N_KEY_LABEL_PAST_SEARCH ]:"Mục tìm kiếm trước đây",
    [KEYS.L18N_KEY_LABEL_ROLES ]:"Vai trò ",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGY ]:"Công nghệ",
    [KEYS.L18N_KEY_LABEL_INDUSTRIES ]:"Ngành",
    [KEYS.L18N_KEY_LABEL_INTEGRATORS ]:"Nhà tích hợp",
    [KEYS.L18N_KEY_LABEL_PROVIDERS ]:"Nhà cung cấp",
    [KEYS.L18N_KEY_LABEL_OTHER ]:"Khác",
    [KEYS.L18N_KEY_LABEL_OTHERS ]:"Khác",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_OTHER_PARTNERS]:"Chưa lưu đối tác khác",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_INTEGRATORS ]:"Chưa lưu nhà tích hợp nào",
    [KEYS.L18N_KEY_LABEL_NO_SAVED_PROVIDERS ]:"Chưa lưu nhà cung cấp nào",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED ]:"lọc theo nhu cầu",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_COMBINED_CRITERIA ]:"tìm theo tiêu chí kết hợp",
    [KEYS.L18N_KEY_LABEL_SEARCH_BY_LOCATION ]:"tìm theo địa điểm",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_WORLDWIDE]:"Có 1 Đối tác phục vụ trên toàn cầu",
    [KEYS.L18N_KEY_LABEL_THERE_ARE]:"Có",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_WORLDWIDE]:"đối tác phục vụ trên toàn cầu",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_NO_PARTNERS_SERVING]:"Không có đối tác nào phục vụ",
    [KEYS.L18N_KEY_LABEL_THERE_IS_ONE_PARTNER_SERVING_IN]:"Có 1 đối tác phục vụ ở",
    [KEYS.L18N_KEY_LABEL_PARTNERS_SERVING_IN]:"đối tác phục vụ ở",
    [KEYS.L18N_KEY_LABEL_THERE_ARE_ONE_PARTNERS_SERVING_IN]:"Không có đối tác nào phục vụ ở",
    [KEYS.L18N_KEY_LABEL_CHANGE_LOCATION]:"Thay đổi địa điểm",
    [KEYS.L18N_KEY_LABEL_FILTER_BY_NEED]:"Lọc theo nhu cầu",
    [KEYS.L18N_KEY_LABEL_SEARCH]:"Tìm kiếm",
    [KEYS.L18N_KEY_LABEL_BY_NAME_ONE_LEVEL_AND_EXPERTISE]:"theo tên, cấp độ và chuyên môn",
    [KEYS.L18N_KEY_LABEL_SELECTED]:"đã chọn",
    [KEYS.L18N_KEY_LABEL_NO_MATCHES_FOUND]:"Không tìm thấy kết quả nào phù hợp",
    [KEYS.L18N_KEY_LABEL_RANK_UP]:"Thăng hạng",
    [KEYS.L18N_KEY_LABEL_RANK_DOWN]:"Tụt hạng",
    [KEYS.L18N_KEY_LABEL_NAME_UP]:"Đưa tên lên",
    [KEYS.L18N_KEY_LABEL_NAME_DOWN]:"Đưa tên xuống",
    [KEYS.L18N_KEY_LABEL_LOGIN_REQUIRED]:"Yêu cầu đăng nhập",
    [KEYS.L18N_KEY_LABEL_YOU_MUST_ONE_PERFORM_THIS_ACTION]:"Bạn phải đăng nhập để thực hiện hành động này",
    [KEYS.L18N_KEY_LABEL_SEARCH_RESTORATION_FAILED]:"Không khôi phục được mục tìm kiếm",
    [KEYS.L18N_KEY_LABEL_LOG_IN]:"Đăng nhập",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_SAVED]:"Đã lưu thành công đối tác!",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_SAVED]:"Không thể lưu đối tác",
    [KEYS.L18N_KEY_LABEL_PARTNER_SUCCESSFULLY_REMOVED]:"Đã xóa thành công đối tác",
    [KEYS.L18N_KEY_LABEL_THE_PARTNER_ONE_NOT_BE_DELETED]:"Không thể xóa đối tác",
    [KEYS.L18N_KEY_LABEL_TYPE_A_ONE_LEVEL_OR_EXPERTISE]:"Nhập một từ khóa để tìm kiếm theo tên, cấp độ hoặc chuyên môn",
    [KEYS.L18N_KEY_LABEL_ROLE_DEVELOPER_DESCRIPTION]:"Nhà phát triển là những chuyên gia xây dựng các giải pháp phần mềm và phần cứng phù hợp dựa trên công nghệ của Cisco, qua đó tạo ra các giải pháp độc đáo giúp kết nối các hệ thống để mang lại kết quả.",
    [KEYS.L18N_KEY_LABEL_ROLE_ADVISOR_DESCRIPTION]:"Cố vấn là những chuyên gia có kiến thức chuyên sâu về ngành, là người chỉ dẫn cho các doanh nghiệp trên hành trình tìm kiếm giải pháp cho những bài toán kinh doanh hóc búa.​",
    [KEYS.L18N_KEY_LABEL_DIVERSE_PARTNER]:"Đối tác đa dạng",
    [KEYS.L18N_KEY_LABEL_ALPHABETICAL]:"Theo bảng chữ cái",
    [KEYS.L18N_KEY_LABEL_MOST_EXPERTISE]:"Chuyên môn cao nhất",
    [KEYS.L18N_KEY_LABEL_DEVELOPER]:"Nhà phát triển",
    [KEYS.L18N_KEY_LABEL_ADVISOR]:"Cố vấn",

    [KEYS.L18N_KEY_LABEL_FILTERS]:"Bộ lọc",
    [KEYS.L18N_KEY_LABEL_FILTER_VERB]:"Lọc",
    [KEYS.L18N_KEY_LABEL_PARTNER_EXPERTISE]:"Chuyên môn của đối tác",
    [KEYS.L18N_KEY_LABEL_DISMISS_VERB]:"Bỏ qua",
    [KEYS.L18N_KEY_LABEL_SPECIALIZATION]:"Chuyên môn",
    [KEYS.L18N_KEY_LABEL_EXPERTISES]:"Chuyên môn",
    [KEYS.L18N_KEY_LABEL_NO_DESCRIPTION_PROVIDED_DOT]:"Không có mô tả.",
    [KEYS.L18N_KEY_LABEL_ABOUT]:"Giới thiệu",
    [KEYS.L18N_KEY_LABEL_CLEAR_COMPARATOR]:"Xóa bộ so sánh",
    [KEYS.L18N_KEY_LABEL_PARTNER_COMPARISON]:"So sánh đối tác",
    [KEYS.L18N_KEY_LABEL_ROLE]:"Vai trò",
    [KEYS.L18N_KEY_LABEL_TECHNOLOGICAL_FOCUS]:"Trọng tâm công nghệ",
    [KEYS.L18N_KEY_LABEL_DESCRIPTION]:"Mô tả",
    [KEYS.L18N_KEY_LABEL_CHOOSE_LANGUAGE_SELECTION]:"Chọn lựa chọn ngôn ngữ",
    [KEYS.L18N_KEY_LABEL_LOG_OUT]:"Đăng xuất",
    [KEYS.L18N_KEY_LABEL_INCLUSIVE_PARTNER]:"Đối tác hòa nhập",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Giới thiệu về Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Liên hệ với chúng tôi",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Nghề nghiệp",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Gặp gỡ Đối tác của chúng tôi",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Phản hồi",
    [KEYS.L18N_KEY_LABEL_HELP]: "Trợ giúp",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Điều khoản & điều kiện",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Tuyên bố về quyền riêng tư",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookie",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Nhãn hiệu",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Tính minh bạch của chuỗi cung ứng",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Sơ đồ trang web",

    [KEYS.L18N_KEY_LABEL_ABOUT_CISCO]: "Giới thiệu về Cisco",
    [KEYS.L18N_KEY_LABEL_CONTACT_US]: "Liên hệ với chúng tôi",
    [KEYS.L18N_KEY_LABEL_CAREERS]: "Nghề nghiệp",
    [KEYS.L18N_KEY_LABEL_MEET_OUR_PARTNERS]: "Gặp gỡ Đối tác của chúng tôi",
    [KEYS.L18N_KEY_LABEL_FEEDBACK]: "Phản hồi",
    [KEYS.L18N_KEY_LABEL_HELP]: "Trợ giúp",
    [KEYS.L18N_KEY_LABEL_TERMS_AND_CONDITIONS]: "Điều khoản và điều kiện",
    [KEYS.L18N_KEY_LABEL_PRIVACY_STATEMENT]: "Tuyên bố về quyền riêng tư",
    [KEYS.L18N_KEY_LABEL_COOKIES]: "Cookie",
    [KEYS.L18N_KEY_LABEL_TRADEMARKS]: "Nhãn hiệu",
    [KEYS.L18N_KEY_LABEL_SUPPLY_CHAIN_TRANSPARENCY]: "Tính minh bạch của chuỗi cung ứng",
    [KEYS.L18N_KEY_LABEL_SITEMAP]: "Sơ đồ trang web",
    [KEYS.L18N_KEY_LABEL_HOW_TO_BUY]: "Cách mua",
    [KEYS.L18N_KEY_LABEL_PARTNERS]: "Đối tác",
    [KEYS.L18N_KEY_LABEL_PRODUCTS_AND_SERVICES]: "Sản phẩm và dịch vụ",
    [KEYS.L18N_KEY_LABEL_SOLUTIONS]: "Giải pháp",
    [KEYS.L18N_KEY_LABEL_SUPPORT]: "Hỗ trợ",
    [KEYS.L18N_KEY_LABEL_LEARN]: "Tìm hiểu",
    [KEYS.L18N_KEY_LABEL_EXPLORE_CISCO]: "Khám phá Cisco",
    [KEYS.L18N_KEY_LABEL_MENU]: "Trình đơn",
    [KEYS.L18N_KEY_LABEL_CLOSE]: "Đóng",
    [KEYS.L18N_KEY_LABEL_SEE_MORE]: "Xem thêm",
    [KEYS.L18N_KEY_LABEL_SEE_LESS]: "Xem ít hơn",
    [KEYS.L18N_KEY_LABEL_DONT_HAVE_AN_ACCOUNT]: "Bạn chưa có tài khoản?",
    [KEYS.L18N_KEY_LABEL_SIGN_UP]: "đăng ký"
}
});

export default viVNTranslations;
